import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import SignaturePad from "signature_pad";
import { AppService } from "src/app/_services/app.service";

@Component({
  selector: "app-signature-pad",
  templateUrl: "./signature-pad.component.html",
  styleUrls: ["./signature-pad.component.scss"],
  standalone: false,
})
export class SignaturePadComponent implements OnInit {
  @ViewChild("canvas", { static: true }) canvasEl!: ElementRef;
  @Input() showDelete?: boolean = false;
  @Output() signImage: EventEmitter<string> = new EventEmitter();
  @Output() clearImg: EventEmitter<boolean> = new EventEmitter();
  signaturePad!: SignaturePad;

  constructor(private appService: AppService, private elementRef: ElementRef) {}

  ngOnInit() {
    this.subscribeCleaning();
  }

  ngAfterViewInit() {
    this.initPad();
  }

  subscribeCleaning() {
    this.appService.cleaningSignatuerPadObservable().subscribe((data) => {
      if (data) {
        this.clearPad();
        this.triggerClearSignature();
        this.clearImg.emit(true);
      }
    });
  }

  triggerClearSignature() {
    this.appService.dispatchModal("CLEAR_PAD", false);
  }

  initPad() {
    const canvas: any = this.elementRef.nativeElement.querySelector("canvas");
    this.signaturePad = new SignaturePad(canvas!);
    this.signaturePad.penColor = "#DF1B1B";
    canvas!.addEventListener("mouseup", () => this.finishedDrawing());
    canvas!.addEventListener("touchend", () => this.finishedDrawing());
    canvas!.addEventListener("mouseleave", () => this.finishedDrawing());
  }

  savePad() {
    const base64Data = this.signaturePad.toDataURL();
    this.signImage.emit(base64Data);
  }
  finishedDrawing() {
    this.savePad();
  }
  startDrawing(event: Event) {}
  moved(event: Event) {}
  clearPad() {
    this.signaturePad.clear();
    this.clearImg.emit(true);
  }
}
